// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import {
  SpanWithData,
  Card,
  LabelledDetail as Detail,
  Grid,
  SvgIcon
} from '../'

import { REQUESTTYPE_IDENTITYBANKACCOUNT_CREATE } from '../../constants'
import { QUERY_CASERELATIONS } from '../../queries'
import { decodeBase64 } from '../../utils'


export const RequestsBankAccountCreate = ({ title, identityId, onRequestClick, requestStatus, orderBy, className }) => (
  <Fragment>
    <div className={`u-font-size-larger u-font-weight-bold slds-m-top_medium slds-m-bottom_small ${className}`}>
      <SvgIcon
        variant='utility'
        symbol='info'
        size='small'
        colour='light'
        className='slds-p-right_small'
      />
      {title}
    </div>
    <Query
      query={gql`
        query($identityId: UUID!, $requestTypeId: UUID!, $orderBy: String) {
          requestruns(identity_Id: $identityId, requesttype_Id: $requestTypeId, orderBy: $orderBy) {
            edges {
              node {
                id
                content
                status
              }
            }
          }
        }
      `}
      variables={{
        identityId: decodeBase64(identityId),
        requestTypeId: decodeBase64(REQUESTTYPE_IDENTITYBANKACCOUNT_CREATE),
        orderBy
      }}>

      {({ loading, error, data }) => {
        if (loading || error) {
          return null
        }

        // get all 'open' requests
        const requests = data.requestruns.edges.filter(({ node: requestrun }) => {
          if (requestStatus) {
            return requestrun.status === requestStatus
          } else {
            // check that status is not one of the 'closed' ones
            return ['PROCESSED', 'CLOSED_CANCELLED', 'CLOSED_DUPLICATE'].indexOf(requestrun.status) === -1
          }
        })

        if (requests.length === 0) {
          return "None"
        }

        return requests.map(({ node: request }) => {
          const capturedContent = JSON.parse(request.content)

          const bankName = capturedContent['bank_name'].value || '-'
          const accountNumber = capturedContent['account_number'].value || '-'

          if (requestStatus === 'CLOSED_CANCELLED') {
            return (
              <Query query={QUERY_CASERELATIONS} variables={{ objectId: decodeBase64(request.id) }}>
                {({ loading, error, data }) => {
                  return (
                    <Card
                      body={
                        <Grid
                          columns={3}
                          items={[
                            <Detail
                              label='Bank'
                              detail={<SpanWithData forField='BankAccountBankName' searchKey={bankName} />}
                              detailFontSize='small'
                              detailFontWeight={600}
                            />,
                            <Detail
                              label='Account no.'
                              detail={accountNumber}
                              detailFontSize='small'
                              detailFontWeight={600}
                            />,
                            <Detail
                              label='Request status'
                              detail={<SpanWithData forField='RequestRunStatus' searchKey={request.status} />}
                              detailFontSize='small'
                              detailFontWeight={600}
                            />
                          ]}
                        />
                      }
                      onClick={() => data.caserelations.edges.length === 0
                        ? onRequestClick(request.id)
                        : loading || error
                          ? null
                          : onRequestClick(data.caserelations.edges[0].node.case.id)
                      }
                      key={`requests_${request.id}`}
                    />
                  )
                }}
              </Query>
            )
          } else {
            return (
              <Card
                body={
                  <Grid
                    columns={3}
                    items={[
                      <Detail
                        label='Bank'
                        detail={<SpanWithData forField='BankAccountBankName' searchKey={bankName} />}
                        detailFontSize='small'
                        detailFontWeight={600}
                      />,
                      <Detail
                        label='Account no.'
                        detail={accountNumber}
                        detailFontSize='small'
                        detailFontWeight={600}
                      />,
                      <Detail
                        label='Request status'
                        detail={<SpanWithData forField='RequestRunStatus' searchKey={request.status} />}
                        detailFontSize='small'
                        detailFontWeight={600}
                      />
                    ]}
                  />
                }
                onClick={() => onRequestClick(request.id)}
                key={`requests_${request.id}`}
              />
            )
          }
        })
      }}
    </Query>
  </Fragment>
)

RequestsBankAccountCreate.propTypes = {
  title: PropTypes.string,
  identityId: PropTypes.string.isRequired,
  onRequestClick: PropTypes.func.isRequired,
  requestStatus: PropTypes.string,
  orderBy: PropTypes.string,
  className: PropTypes.string
}

RequestsBankAccountCreate.defaultProps = {
  title: 'Requests in process',
  orderBy: '-created_at',
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/identity-bankaccounts/RequestsBankAccountCreate.js